<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaCamposAdicionais"
        title-table="Campos Adicionais"
        module="camposAdicionaisSettingsModule"
        sort-name="descricao"
        :show-btn-add="verificarPermissao('ROLE_ATEND_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_ATEND_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormCampoAdicional v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormCampoAdicional from './forms/FormCampoAdicional.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormCampoAdicional
  },
  computed: {
    ...mapState('camposAdicionaisSettingsModule', {
      listaCamposAdicionais: (state) => state.listaCamposAdicionais
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id'
        },
        {
          label: 'Nome',
          field: 'nome'
        },
        {
          label: 'Descricao',
          field: 'descricao'
        },
        {
          label: 'Tipo',
          field: 'tipo'
        },
        {
          label: 'Procedimento',
          field: 'procedimento.descricao'
        },
        {
          label: 'Ativo',
          field: 'ativo'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'nome',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('camposAdicionaisSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
